import React from 'react';

export const HOCList = ItemComponent => {
	return props => {
		const { body, styles, actionName, guestMode } = props;
		return (
			body &&
			body[0] && (
				<div className="hello">
					{body.map(item => (
						<div key={item.id} className="item-wrapper">
							<ItemComponent
								guestMode={guestMode}
								componentData={item}
								actionName={actionName}
							/>
						</div>
					))}
				</div>
			)
		);
	};
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/components/HOC/HOCList.js